// frontend/src/pages/AiLearning.jsx
import React, { useState, useRef, useEffect } from "react";
import { ArrowLeft, Sparkles, Music, Mic, BookOpen, Send, Trophy, X } from "lucide-react";
import chatbotIcon from "../assets/img/chatbot.png"; 

// Dữ liệu 6 Modules gốc tích hợp 5 câu hỏi Quiz mỗi phần
const MODULES = [
  {
    id: 1,
    title: "Lịch sử & Ý nghĩa Sắc Bùa",
    desc: "Tìm hiểu nguồn gốc, lịch sử và ý nghĩa văn hóa của Sắc Bùa Phú Lễ",
    icon: <BookOpen className="w-7 h-7 text-rose-500" />,
    color: "bg-rose-100",
    borderColor: "border-rose-200",
    textColor: "text-rose-700",
    maxXp: 100,
    content: "Hát Sắc Bùa (còn gọi là Múa Bóng Rỗi) là một loại hình nghệ thuật dân gian đặc sắc của vùng Bến Tre. Loại hình này thường được trình diễn vào dịp Tết Nguyên Đán, mang ý nghĩa cầu an, trừ tà, chúc phúc — xua đuổi điều xui xẻo, mang lại may mắn cho gia chủ. Được công nhận Di sản Văn hóa Phi vật thể Quốc gia năm 2014.",
    quickPrompts: ["Sắc Bùa Phú Lễ có từ bao giờ?", "Ý nghĩa tâm linh là gì?", "Khác gì hát bội?"],
    quiz: [
      { q: "Hát Sắc Bùa Phú Lễ được công nhận là Di sản Văn hóa Phi vật thể Quốc gia vào năm nào?", options: ["2010", "2014", "2016", "2018"], ans: 1 },
      { q: "Mục đích chính của Hát Sắc Bùa vào dịp Tết là gì?", options: ["Thi đấu nghệ thuật", "Cầu an, trừ tà, chúc phúc", "Giao duyên", "Biểu diễn kiếm tiền"], ans: 1 },
      { q: "Tên gọi khác của Hát Sắc Bùa ở Nam Bộ là gì?", options: ["Múa Bóng Rỗi", "Hát Bội", "Đờn ca tài tử", "Hát Xoan"], ans: 0 },
      { q: "Hát Sắc Bùa Phú Lễ có nguồn gốc từ tỉnh nào?", options: ["Long An", "Đồng Tháp", "Bến Tre", "Tiền Giang"], ans: 2 },
      { q: "Đoàn hát Sắc Bùa thường đi đến đâu để biểu diễn?", options: ["Chỉ hát ở đình làng", "Hát trên sân khấu lớn", "Chỉ hát trên thuyền", "Đi từ nhà này sang nhà khác"], ans: 3 }
    ]
  },
  {
    id: 2,
    title: "Học điệu múa cơ bản",
    desc: "Học các bước múa truyền thống với hướng dẫn tương tác",
    icon: <Sparkles className="w-7 h-7 text-emerald-500" />,
    color: "bg-emerald-100",
    borderColor: "border-emerald-200",
    textColor: "text-emerald-700",
    maxXp: 120,
    content: "Bước 1 — Tư thế khởi đầu: Hai chân rộng bằng vai, hơi khuỵu gối. Tay cầm sênh tiền giơ ngang ngực, mắt nhìn thẳng. Bước 2 — Lắc hông: Nhẹ nhàng lắc hông trái-phải theo nhịp trống. Bước 3 — Tiến lùi: Phối hợp chân và tay múa vòng tròn.",
    quickPrompts: ["Hướng dẫn điệu múa cơ bản", "Cách cầm sênh tiền đúng", "Ý nghĩa động tác múa"],
    quiz: [
      { q: "Tư thế khởi đầu đúng khi múa Sắc Bùa là gì?", options: ["Đứng thẳng, tay xuôi", "Hai chân rộng bằng vai, hơi khuỵu gối", "Ngồi xếp bằng", "Chân trước chân sau"], ans: 1 },
      { q: "Trong lúc múa, tay nghệ nhân thường cầm nhạc cụ gì?", options: ["Phách", "Sênh tiền", "Đàn nhị", "Trống đồng"], ans: 1 },
      { q: "Động tác lắc hông cần di chuyển theo nhịp của nhạc cụ nào?", options: ["Nhịp trống", "Tiếng sáo", "Nhịp đàn", "Nhịp hát"], ans: 0 },
      { q: "Khi xoay vòng 360°, người múa cần chú ý điều gì?", options: ["Nhắm mắt lại", "Đứng im tại chỗ", "Hai tay khép chặt", "Tay dang rộng, sênh tiền kêu liên tục"], ans: 3 },
      { q: "Kỹ thuật 'múa đôi' trong Sắc Bùa thường tạo ra hiệu ứng hình ảnh gì?", options: ["Rượt đuổi", "Gương soi", "Leo núi", "Bơi lội"], ans: 1 }
    ]
  },
  {
    id: 3,
    title: "Luyện hát & Karaoke",
    desc: "Luyện giọng hát cùng AI chấm điểm và nhận xét chi tiết",
    icon: <Mic className="w-7 h-7 text-amber-500" />,
    color: "bg-amber-100",
    borderColor: "border-amber-200",
    textColor: "text-amber-700",
    maxXp: 150,
    content: "Kỹ thuật lấy hơi: Hát Sắc Bùa đòi hỏi hơi dài và đều. Hít sâu bằng bụng trước mỗi câu hát. Không hít hơi giữa chừng một câu. Giọng hát cần vui tươi, hóm hỉnh, bắt đúng nhịp 'thùng thình' của trống cơm.",
    quickPrompts: ["Chấm điểm giọng hát của em", "Cách lấy hơi chuẩn", "Bài hát cho người mới"],
    quiz: [
      { q: "Khi hát Sắc Bùa, kỹ thuật lấy hơi đúng là gì?", options: ["Hít bằng ngực", "Hít sâu bằng bụng", "Hít bằng miệng", "Hít hơi liên tục"], ans: 1 },
      { q: "Sắc thái giọng hát Sắc Bùa cần thể hiện điều gì?", options: ["Vui tươi, hóm hỉnh", "Buồn bã, bi lụy", "Hùng hồn, trang nghiêm", "Lạnh lùng"], ans: 0 },
      { q: "Điều gì là TỐI KỴ khi hát một câu Sắc Bùa?", options: ["Hát quá to", "Hát sai lời một chữ", "Hít hơi giữa chừng một câu", "Vừa hát vừa cười"], ans: 2 },
      { q: "Nhịp hát phải bắt khớp với âm thanh của loại trống nào?", options: ["Trống đồng", "Trống cái", "Trống cơm", "Trống jazz"], ans: 2 },
      { q: "Từ tượng thanh đặc trưng để mô tả nhịp trống cơm là gì?", options: ["Tùng tùng", "Thùng thình", "Cắc cụp", "Cheng cheng"], ans: 1 }
    ]
  },
  {
    id: 4,
    title: "Sáng tác lời bài hát",
    desc: "Cùng AI sáng tác những câu hát mang màu sắc hiện đại",
    icon: <Music className="w-7 h-7 text-blue-500" />,
    color: "bg-blue-100",
    borderColor: "border-blue-200",
    textColor: "text-blue-700",
    maxXp: 130,
    content: "Luật thơ Sắc Bùa: Thường dùng thơ lục bát hoặc song thất lục bát. Vần cuối câu 6 chữ vần với chữ thứ 6 của câu 8 chữ tiếp theo. Nội dung xoay quanh chúc sức khỏe, tiền tài, khen cảnh nhà đẹp.",
    quickPrompts: ["Sáng tác lời chủ đề Tết", "Viết câu chúc sức khỏe", "Luật thơ lục bát"],
    quiz: [
      { q: "Thể thơ phổ biến nhất được sử dụng trong Hát Sắc Bùa là gì?", options: ["Thơ tự do", "Thơ Đường luật", "Thơ lục bát", "Thơ 4 chữ"], ans: 2 },
      { q: "Theo luật thơ lục bát, từ cuối của câu 6 chữ phải vần với từ thứ mấy của câu 8 chữ?", options: ["Thứ 4", "Thứ 6", "Thứ 8", "Thứ 2"], ans: 1 },
      { q: "Nội dung truyền thống của lời hát Sắc Bùa thường hướng đến ai?", options: ["Gia chủ", "Chính quyền", "Người đi đường", "Trẻ em"], ans: 0 },
      { q: "Trong lời hát, người ta KHÔNG thường nhắc đến điều gì?", options: ["Mùa màng bội thu", "Chúc sức khỏe", "Chuyện buồn phiền năm cũ", "Tài lộc năm mới"], ans: 2 },
      { q: "Có thể sáng tác lời Sắc Bùa theo các chủ đề hiện đại không?", options: ["Tuyệt đối không", "Chỉ được đổi 1-2 từ", "Rất khuyến khích để bảo tồn và làm mới", "Chỉ người già mới được sáng tác"], ans: 2 }
    ]
  },
  {
    id: 5,
    title: "Hóa thân nghệ nhân",
    desc: "Thử mặc trang phục ảo và hóa thân thành nhân vật",
    icon: <Sparkles className="w-7 h-7 text-purple-500" />,
    color: "bg-purple-100",
    borderColor: "border-purple-200",
    textColor: "text-purple-700",
    maxXp: 140,
    content: "Trang phục bao gồm Áo bà ba (màu sặc sỡ), Khăn rằn và Mặt nạ. Các nhân vật mặt nạ đặc trưng: Ông Địa (mặt tròn, má đỏ tượng trưng đất đai), Thần Tài (mang tài lộc), Thiên Quan, và Hề.",
    quickPrompts: ["Trang phục gồm những gì?", "Ý nghĩa mặt nạ Ông Địa", "Cách trang điểm"],
    quiz: [
      { q: "Mặt nạ Ông Địa trong đội Sắc Bùa đại diện cho điều gì?", options: ["Sức mạnh chiến đấu", "Sự sung túc, đất đai màu mỡ", "Bầu trời", "Biển cả"], ans: 1 },
      { q: "Trang phục áo bà ba của đội Sắc Bùa thường có màu sắc như thế nào?", options: ["Sặc sỡ (đỏ, vàng)", "Trắng toát", "Đen tuyền", "Xám tro"], ans: 0 },
      { q: "Phụ kiện quấn trên đầu thường thấy của nghệ nhân Nam Bộ là gì?", options: ["Khăn xếp", "Mũ phớt", "Khăn rằn", "Nón quai thao"], ans: 2 },
      { q: "Đặc điểm nhận dạng của mặt nạ nhân vật Hề là gì?", options: ["Mặt rồng", "Mặt nửa trắng nửa đen", "Mặt có râu dài", "Mặt trơn không vẽ"], ans: 1 },
      { q: "Mặt nạ Thần Tài mang ý nghĩa chúc gia chủ điều gì?", options: ["Học hành đỗ đạt", "Tài lộc, may mắn", "Trường thọ", "Mưa thuận gió hòa"], ans: 1 }
    ]
  },
  {
    id: 6,
    title: "Nhạc cụ & Trang phục",
    desc: "Tìm hiểu về trống cơm, sênh tiền truyền thống",
    icon: <Music className="w-7 h-7 text-cyan-500" />,
    color: "bg-cyan-100",
    borderColor: "border-cyan-200",
    textColor: "text-cyan-700",
    maxXp: 110,
    content: "Trống cơm: Mặt trống dán cơm nguội trộn tro để tạo độ căng. Đánh bằng tay không, nhịp 'thùng' (chính) và 'thình' (phụ). Sênh tiền: Làm từ tre/gỗ gắn đồng xu, tạo âm thanh 'xích xích' liên tục.",
    quickPrompts: ["Cách đánh trống cơm", "Sênh tiền làm bằng gì?", "Bảo quản nhạc cụ"],
    quiz: [
      { q: "Tại sao nhạc cụ chính lại có tên là 'Trống cơm'?", options: ["Hình dáng giống bát cơm", "Mặt trống được dán bằng cơm nguội trộn tro", "Làm từ vỏ cây lúa", "Người đánh trống hay ăn cơm"], ans: 1 },
      { q: "Nhạc cụ Sênh tiền được cấu tạo chủ yếu từ vật liệu gì?", options: ["Tre/gỗ gắn đồng xu", "Nhựa tổng hợp", "Sắt đặc", "Đá cuội"], ans: 0 },
      { q: "Nghệ nhân dùng dụng cụ gì để đánh trống cơm Sắc Bùa?", options: ["Dùi gỗ", "Tay không", "Dùi sắt", "Thanh tre"], ans: 1 },
      { q: "Âm thanh đặc trưng phát ra từ sênh tiền được miêu tả như thế nào?", options: ["Tùng tùng", "Boong boong", "Xích xích", "Đùng đùng"], ans: 2 },
      { q: "Trong kỹ thuật đánh trống cơm, nhịp 'Thùng' đóng vai trò là nhịp gì?", options: ["Nhịp chính", "Nhịp phụ", "Nhịp báo kết thúc", "Nhịp lấy đà"], ans: 0 }
    ]
  }
];

const AiLearning = () => {
  const [activeModule, setActiveModule] = useState(null);
  
  const [userXp, setUserXp] = useState(() => {
    const saved = localStorage.getItem('sacbua_xp');
    return saved ? JSON.parse(saved) : {};
  });

  const [userFeedback, setUserFeedback] = useState(() => {
    const savedFeedback = localStorage.getItem('sacbua_feedback');
    return savedFeedback ? JSON.parse(savedFeedback) : {};
  });

  useEffect(() => {
    localStorage.setItem('sacbua_xp', JSON.stringify(userXp));
  }, [userXp]);

  useEffect(() => {
    localStorage.setItem('sacbua_feedback', JSON.stringify(userFeedback));
  }, [userFeedback]);

  const totalXp = Object.values(userXp).reduce((a, b) => a + b, 0);

  const addXp = (moduleId, amount) => {
    setUserXp(prev => {
      const current = prev[moduleId] || 0;
      const max = MODULES.find(m => m.id === moduleId).maxXp;
      const newXp = Math.min(current + amount, max);
      return { ...prev, [moduleId]: newXp };
    });
  };

  // VIEW 1: DASHBOARD
  if (!activeModule) {
    return (
      <div className="min-h-full bg-slate-50 p-4 sm:p-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8 bg-white border-4 border-slate-200 rounded-3xl p-5 shadow-sm">
            <div>
              <h1 className="text-2xl font-bold text-slate-800 mb-1">Học Cùng Trợ Lý AI</h1>
              <p className="text-sm text-slate-600 font-medium">Khám phá di sản văn hóa phi vật thể Sắc Bùa Phú Lễ</p>
            </div>
            <div className="mt-4 md:mt-0 flex items-center gap-3 bg-amber-50 border-4 border-amber-200 px-5 py-2.5 rounded-2xl">
              <Trophy className="w-5 h-5 text-amber-500" />
              <div>
                <p className="text-[10px] text-amber-700 font-bold uppercase">Tổng điểm tích lũy</p>
                <p className="text-lg font-extrabold text-amber-600">{totalXp} XP</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {MODULES.map((mod) => {
              const currentXp = userXp[mod.id] || 0;
              const progress = Math.min(100, Math.round((currentXp / mod.maxXp) * 100));
              const isCompleted = progress >= 100;

              return (
                <div 
                  key={mod.id} 
                  onClick={() => setActiveModule(mod)}
                  className={`bg-white border-4 ${isCompleted ? 'border-amber-300' : 'border-slate-200'} rounded-3xl p-5 cursor-pointer hover:-translate-y-1.5 hover:shadow-lg transition-all flex flex-col`}
                >
                  <div className="flex items-start gap-3 mb-3">
                    <div className={`p-3 rounded-2xl ${mod.color} border-4 ${mod.borderColor}`}>
                      {mod.icon}
                    </div>
                  </div>
                  <div className="flex-1 mb-4">
                    <h3 className="text-base font-bold text-slate-800 leading-tight mb-1.5">{mod.title}</h3>
                    <p className="text-xs text-slate-600 font-medium line-clamp-2">{mod.desc}</p>
                  </div>
                  
                  <div className="mt-auto">
                    <div className="flex justify-between items-center text-[11px] font-bold text-slate-500 mb-2">
                      <span>{isCompleted ? "Đã hoàn thành" : "Tiến độ"}</span>
                      <span className={isCompleted ? "text-amber-600" : mod.textColor}>
                        {currentXp} / {mod.maxXp} XP
                      </span>
                    </div>
                    <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden border border-slate-200">
                      <div 
                        className={`h-full rounded-full transition-all duration-1000 ${isCompleted ? 'bg-amber-400' : 'bg-slate-400'}`}
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    {userFeedback[mod.id] && (
                      <div className="mt-3 bg-amber-50 p-2.5 rounded-xl border border-amber-200 text-[11px] text-amber-800 italic font-medium line-clamp-1">
                        "{userFeedback[mod.id]}"
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // VIEW 2: CHI TIẾT MODULE
  return (
    <ModuleDetailView 
      module={activeModule} 
      onBack={() => setActiveModule(null)}
      currentXp={userXp[activeModule.id] || 0}
      onAddXp={(amount) => addXp(activeModule.id, amount)}
      userFeedback={userFeedback}
      setUserFeedback={setUserFeedback}
    />
  );
};

// ==========================================
// COMPONENT CHI TIẾT 1 BÀI HỌC VÀ CHAT
// ==========================================
const ModuleDetailView = ({ module, onBack, currentXp, onAddXp, userFeedback, setUserFeedback }) => {
  const [messages, setMessages] = useState([
    { id: 1, text: `Chào bạn! Thầy AI đây. Mình bắt đầu bài học "${module.title}" nhé. Bạn có câu hỏi nào không?`, isBot: true, time: new Date() }
  ]);
  const [inputMsg, setInputMsg] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  
  const [showQuiz, setShowQuiz] = useState(false);
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [isQuizSubmitted, setIsQuizSubmitted] = useState(false);
  const [finalScore, setFinalScore] = useState(0);

  const endOfMsgRef = useRef(null);

  useEffect(() => {
    endOfMsgRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  const handleSend = (text) => {
    const finalMsg = typeof text === 'string' ? text : inputMsg;
    if (!finalMsg.trim()) return;

    setMessages(prev => [...prev, { id: Date.now(), text: finalMsg, isBot: false, time: new Date() }]);
    setInputMsg("");
    setIsTyping(true);
    onAddXp(5); 

    setTimeout(() => {
      setMessages(prev => [...prev, { 
        id: Date.now() + 1, 
        text: `Câu hỏi rất hay! Về việc "${finalMsg}", bạn có thể nhớ rằng ${module.content.substring(0, 50)}...`, 
        isBot: true, 
        time: new Date() 
      }]);
      setIsTyping(false);
    }, 1500);
  };

  const handleSelectOption = (idx) => {
    if (isQuizSubmitted) return;
    setSelectedAnswers(prev => ({ ...prev, [currentQIndex]: idx }));
  };

  const handlePrevQuestion = () => setCurrentQIndex(prev => Math.max(0, prev - 1));
  const handleNextQuestion = () => setCurrentQIndex(prev => Math.min(module.quiz.length - 1, prev + 1));

  const handleSubmitQuiz = () => {
    let score = 0;
    module.quiz.forEach((q, index) => {
      if (selectedAnswers[index] === q.ans) score++;
    });
    setFinalScore(score);
    setIsQuizSubmitted(true);

    const earnedXp = score * 15;
    if (earnedXp > 0) onAddXp(earnedXp);

    let feedbackText = "";
    if (score === module.quiz.length) {
      feedbackText = "Xuất sắc! Em đã trả lời đúng toàn bộ câu hỏi và nắm rất vững kiến thức văn hóa. Thầy rất tự hào!";
    } else if (score >= 3) {
      feedbackText = `Khá lắm! Em trả lời đúng ${score}/${module.quiz.length} câu. Hãy xem lại bài một chút để đạt điểm tối đa nhé.`;
    } else {
      feedbackText = `Cần cố gắng hơn! Em mới đúng ${score}/${module.quiz.length} câu. Hãy đọc kỹ lại phần nội dung cốt lõi và làm lại bài nhé.`;
    }
    setUserFeedback(prev => ({ ...prev, [module.id]: feedbackText }));
  };

  const handleCloseQuiz = () => {
    setShowQuiz(false);
    setCurrentQIndex(0);
    setSelectedAnswers({});
    if (isQuizSubmitted) {
      setIsQuizSubmitted(false);
      onBack(); 
    }
  };

  const formatTime = (date) => date.toLocaleTimeString("vi-VN", { hour: "2-digit", minute: "2-digit" });
  const isAllAnswered = Object.keys(selectedAnswers).length === module.quiz.length;

  return (
    <div className="min-h-full bg-slate-50 p-4 sm:p-8">
      <div className="max-w-5xl mx-auto flex flex-col gap-6 relative">
        
        {/* NỘI DUNG BÀI HỌC */}
        <div className="w-full relative flex flex-col">
          <div className="flex justify-between items-center mb-5">
            <button onClick={onBack} className="flex items-center gap-2 text-slate-600 text-sm font-bold bg-white border-4 border-slate-200 px-4 py-2 rounded-xl hover:bg-slate-100 transition-colors">
              <ArrowLeft className="w-4 h-4" /> Trở về
            </button>
            <div className="bg-white border-4 border-slate-200 px-4 py-2 rounded-xl text-sm font-bold text-amber-600 flex items-center gap-2">
              ⭐ {currentXp} / {module.maxXp} XP
            </div>
          </div>

          <div className="bg-white border-4 border-slate-200 rounded-3xl p-6 lg:p-8 shadow-sm relative overflow-hidden flex flex-col flex-1">
            <div className="flex items-center gap-4 mb-6">
              <div className={`p-3.5 rounded-2xl ${module.color} border-4 ${module.borderColor}`}>
                {module.icon}
              </div>
              <h2 className="text-xl lg:text-3xl font-extrabold text-slate-800 leading-tight">{module.title}</h2>
            </div>
            
            <div className="prose max-w-none text-slate-600 font-medium flex-1">
              <div className="bg-slate-50 border-4 border-slate-100 p-5 rounded-2xl mb-6 text-sm lg:text-base">
                {module.desc}
              </div>
              <h4 className="text-base font-bold text-slate-800 mb-3">Nội dung cốt lõi:</h4>
              <p className="bg-blue-50 border-l-8 border-blue-300 p-5 rounded-r-2xl rounded-l-md text-slate-700 text-base leading-relaxed">
                {module.content}
              </p>
            </div>

            {userFeedback[module.id] && (
              <div className="mt-6 p-5 bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-200 rounded-2xl relative animate-in fade-in zoom-in duration-300">
                <div className="absolute -top-3 left-5 bg-amber-500 text-white px-3 py-0.5 rounded-full text-[10px] font-bold shadow-md">
                  Nhận xét từ Thầy AI
                </div>
                <p className="text-slate-700 font-medium text-sm italic mt-1">
                  "{userFeedback[module.id]}"
                </p>
              </div>
            )}
            
            <div className="mt-8 flex justify-center w-full">
              <button 
                onClick={() => { setShowQuiz(true); setIsQuizSubmitted(false); setSelectedAnswers({}); setCurrentQIndex(0); }}
                className="bg-rose-100 text-rose-700 border-4 border-rose-200 font-bold px-8 py-3.5 rounded-2xl hover:bg-rose-200 hover:scale-105 transition-all flex items-center gap-2.5 text-sm w-max"
              >
                📝 {userFeedback[module.id] ? "Làm lại bài kiểm tra" : `Bắt đầu kiểm tra (${module.quiz.length} câu)`}
              </button>
            </div>

            {/* QUIZ MODAL */}
            {showQuiz && (
              <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm z-20 flex items-center justify-center p-4">
                <div className="bg-white rounded-3xl w-full max-w-xl shadow-2xl flex flex-col max-h-[95%] overflow-hidden animate-in zoom-in-95 duration-200">
                  <div className="flex justify-between items-center p-4 border-b border-slate-100 bg-slate-50">
                    <h3 className="text-base font-bold text-slate-800">
                      {isQuizSubmitted ? "Kết quả kiểm tra" : `Bài kiểm tra (${currentQIndex + 1}/${module.quiz.length})`}
                    </h3>
                    <button onClick={handleCloseQuiz} className="text-slate-400 hover:text-rose-500 transition-colors bg-white rounded-full p-1.5 border border-slate-200">
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                  
                  <div className="p-5 overflow-y-auto">
                    {!isQuizSubmitted ? (
                      <>
                        <div className="text-sm font-bold text-slate-700 mb-4 bg-blue-50 p-4 rounded-xl border border-blue-100 leading-relaxed">
                          {module.quiz[currentQIndex].q}
                        </div>
                        
                        <div className="grid grid-cols-1 gap-2.5">
                          {module.quiz[currentQIndex].options.map((opt, idx) => {
                            const isSelected = selectedAnswers[currentQIndex] === idx;
                            return (
                              <button
                                key={idx}
                                onClick={() => handleSelectOption(idx)}
                                className={`p-3 rounded-xl border-2 font-semibold text-sm text-left transition-all ${
                                  isSelected 
                                    ? 'bg-blue-100 border-blue-400 text-blue-800 shadow-sm' 
                                    : 'bg-white border-slate-200 text-slate-600 hover:border-blue-300 hover:bg-blue-50'
                                }`}
                              >
                                {opt}
                              </button>
                            );
                          })}
                        </div>

                        <div className="mt-6 flex justify-between items-center">
                          <button 
                            onClick={handlePrevQuestion}
                            disabled={currentQIndex === 0}
                            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all ${
                              currentQIndex === 0 ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'bg-white border-2 border-slate-200 text-slate-600 hover:bg-slate-50'
                            }`}
                          >
                            Trước
                          </button>

                          {currentQIndex < module.quiz.length - 1 ? (
                            <button 
                              onClick={handleNextQuestion}
                              className="px-4 py-2.5 rounded-xl font-bold text-xs bg-blue-100 text-blue-700 border-2 border-blue-200 hover:bg-blue-200 transition-all"
                            >
                              Sau
                            </button>
                          ) : (
                            <button 
                              onClick={handleSubmitQuiz}
                              disabled={!isAllAnswered}
                              className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all ${
                                !isAllAnswered
                                  ? 'bg-slate-100 text-slate-400 border-2 border-slate-200 cursor-not-allowed'
                                  : 'bg-rose-500 text-white border-2 border-rose-600 hover:bg-rose-600 shadow-md'
                              }`}
                            >
                              Hoàn thành
                            </button>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="text-center py-5 animate-in fade-in duration-300">
                        <Trophy className="w-16 h-16 text-amber-400 mx-auto mb-3 drop-shadow-md" />
                        <h2 className="text-2xl font-extrabold text-slate-800 mb-1">Chúc mừng em!</h2>
                        <p className="text-sm text-slate-600 mb-6 font-medium">Em đã hoàn thành bài kiểm tra.</p>
                        
                        <div className="bg-slate-50 border-2 border-slate-100 rounded-2xl p-5 mb-6 inline-block mx-auto min-w-[260px] shadow-inner">
                          <div className="flex justify-between items-center mb-2">
                            <span className="text-sm text-slate-500 font-bold">Số câu đúng:</span>
                            <span className="text-emerald-600 font-extrabold text-lg">{finalScore} / {module.quiz.length}</span>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-sm text-slate-500 font-bold">XP nhận được:</span>
                            <span className="text-amber-500 font-extrabold text-lg">+{finalScore * 15} XP</span>
                          </div>
                        </div>

                        <button 
                          onClick={handleCloseQuiz}
                          className="w-full bg-rose-500 text-white font-bold py-3.5 rounded-xl hover:bg-rose-600 transition-colors shadow-md text-sm"
                        >
                          Trở về trang học tập
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* KHUNG CHAT AI */}
        <div className="w-full flex flex-col bg-white rounded-3xl shadow-xl border border-gray-200 h-[450px] sm:h-[550px] overflow-hidden">
          <div className="bg-gradient-to-r from-red-600 to-amber-600 p-4 text-white flex items-center justify-between shadow-sm">
            <div className="flex items-center space-x-3">
              <div className="w-9 h-9 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border border-white/40">
                <img src={chatbotIcon} alt="Chatbot" className="w-5 h-5 object-contain" />
              </div>
              <div>
                <h3 className="font-bold text-sm sm:text-base tracking-wide">Thầy Sắc Bùa AI</h3>
                <p className="text-[10px] opacity-90 flex items-center gap-1.5 mt-0.5">
                  <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></span> Đang trực tuyến
                </p>
              </div>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-3 sm:p-5 bg-gray-50 space-y-4">
            {messages.map((msg) => (
              <div key={msg.id} className={`flex ${msg.isBot ? "justify-start" : "justify-end"}`}>
                <div className={`max-w-[90%] sm:max-w-[80%] rounded-2xl p-3 shadow-sm ${
                  msg.isBot 
                    ? "bg-white border border-slate-200 rounded-tl-none" 
                    : "bg-gradient-to-r from-red-500 to-amber-500 text-white rounded-br-none border border-red-400"
                }`}>
                  <p className={`text-sm whitespace-pre-wrap leading-relaxed ${!msg.isBot ? "text-white" : "text-slate-700"}`}>
                    {msg.text}
                  </p>
                  <p className={`text-[10px] mt-1.5 font-medium ${msg.isBot ? "text-slate-400" : "text-red-100"}`}>
                    {formatTime(msg.time)}
                  </p>
                </div>
              </div>
            ))}
            
            {isTyping && (
              <div className="flex justify-start">
                <div className="bg-white border border-slate-200 rounded-2xl rounded-tl-none p-3 flex gap-2 items-center shadow-sm">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce"></div>
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{animationDelay: "0.1s"}}></div>
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{animationDelay: "0.2s"}}></div>
                </div>
              </div>
            )}
            <div ref={endOfMsgRef} />
          </div>

          <div className="p-2.5 sm:p-3 bg-white border-t border-gray-100">
            <div className="flex gap-2 overflow-x-auto whitespace-nowrap scrollbar-hide pb-1">
              {module.quickPrompts.map((prompt, idx) => (
                <button 
                  key={idx} 
                  onClick={() => handleSend(prompt)}
                  className="inline-flex bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-[11px] font-bold text-slate-600 hover:bg-red-50 hover:text-red-600 hover:border-red-200 transition-colors whitespace-nowrap"
                >
                  {prompt}
                </button>
              ))}
            </div>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); handleSend(inputMsg); }} className="p-3 sm:p-4 bg-white border-t border-slate-100 flex space-x-2">
            <input 
              type="text" 
              value={inputMsg}
              onChange={(e) => setInputMsg(e.target.value)}
              placeholder="Nhập câu hỏi của bạn..."
              className="flex-1 border-2 border-slate-200 bg-slate-50 rounded-xl px-4 py-2.5 text-xs font-medium focus:outline-none focus:border-red-300 focus:bg-white transition-all"
            />
            <button 
              type="submit"
              disabled={!inputMsg.trim() || isTyping}
              className="bg-gradient-to-r from-red-600 to-amber-600 text-white rounded-xl px-4 py-2.5 hover:from-red-700 hover:to-amber-700 transition-all flex-shrink-0 disabled:opacity-50 shadow-sm flex items-center justify-center"
            >
              <Send className="w-4 h-4" />
            </button>
          </form>
        </div>

      </div>
    </div>
  );
};

export default AiLearning;